import OrganizationMemberInviteModel from '@shared/models/organizations/OrganizationMemberInviteModel';
import OrganizationMemberModel from '@shared/models/organizations/OrganizationMemberModel';
import OrganizationMemberRole from '@shared/models/organizations/OrganizationMemberRole';

export const extractRoleProperties = (
    member: OrganizationMemberModel | OrganizationMemberInviteModel
): OrganizationMemberRole => {
    const {
        isAdmin,
        canViewMembers,
        canInviteMembers,
        canChangeMemberPermissions,
        canRemoveMembers,
        canCreateAuthClients,
        canViewAuthClients,
        canManageBilling,
        canManageChildOrganizations,
        canViewAnalytics,
        canAccessOrganizationProfiles,
        canEditOrganizationProfiles,
    } = member;
    return {
        isAdmin,
        canViewMembers,
        canInviteMembers,
        canChangeMemberPermissions,
        canRemoveMembers,
        canCreateAuthClients,
        canViewAuthClients,
        canManageBilling,
        canManageChildOrganizations,
        canViewAnalytics,
        canAccessOrganizationProfiles,
        canEditOrganizationProfiles,
    };
};
